import { createDescriptiveDateDropdownOptions } from '@acorn-portal/shared/src/utils/create-descriptive-date-dropdown-options';
import { addDays, getHours, getMinutes } from 'date-fns';
import { getDateDescriptionOptions } from './get-date-description-options';

/**
 *
 * Generates static dropdown options for the cancellation date form (date description - typically 'Now' or 'Later', and descriptive dates)
 *
 * A note on descriptive date options
 * - If the current time is within the specified minute window before midnight (e.g., if the window is 15 minutes, we consider times after 11:45 PM)
 * the date options will start from the next day.
 * - Otherwise, they start from the current day.
 *
 * @param options - Configuration object
 * @param options.minuteWindow - The minute window before midnight to trigger the date dropdown starting value (default: 15 minutes)
 * @returns An object containing description and date dropdown options
 */
export const getStaticDropdownOptions = (options: { minuteWindow: number }) => {
	const now = new Date();

	let startDate = now;

	if (options.minuteWindow) {
		const currentHour = getHours(now);
		const currentMinute = getMinutes(now);
		const maxMinutes = 60 - options.minuteWindow;

		// If it's in the minute window of the evening, start date options from tomorrow
		const isNearMidnight = currentHour >= 23 && currentMinute >= maxMinutes;
		startDate = isNearMidnight ? addDays(now, 1) : now;
	}

	return {
		description: getDateDescriptionOptions(),
		date: createDescriptiveDateDropdownOptions(7, startDate),
	};
};

export type StaticDropdownOptions = ReturnType<typeof getStaticDropdownOptions>;
